module.exports = __webpack_public_path__ + "static/media/footer_logo.5ec3da60.svg";